import { useList } from 'SharedDir/common/composables/useList';
import { PublicNewsApi } from 'SharedDir/backend/api';
import { makeRequest } from 'SharedDir/common/composables/useRequests';

import { usePublicNewsFilters } from './usePublicNewsFilters';

export function usePublicNewsList() {
  const {
    combinedParameters,
    fetch,
    list,
    paginationParams,
    filterParams,
    onRequest,
    clearParameters,
    fillFromQueryString,
    fillFromQueryStringSsr,
    defaultFilterParams,
    setQueryParams,
  } = useList(usePublicNewsFilters, PublicNewsApi, true, { descending: true, rowsPerPage: 24 });

  const getShortNewsList = async () => {
    const params = {
      page: 1,
      rowsPerPage: 9,
      rowsNumber: 0,
      sortBy: 'publishedAt',
      descending: true,
    };
    const { data: responseData } = await makeRequest(() => PublicNewsApi.getPaginated(params));
    return responseData;
  };

  return {
    fetch,
    paginationParams,
    filterParams,
    onRequest,
    clearParameters,
    list,
    getShortNewsList,
    fillFromQueryString,
    fillFromQueryStringSsr,
    defaultFilterParams,
    setQueryParams,
  };
}
